import { SEVERITY_LEVELS } from 'Util/constants'
import { useSnackbar, type VariantType } from 'notistack'
import type { FC } from 'react'

let useSnackbarRef: ReturnType<typeof useSnackbar>
export const SnackbarUtilsConfigurator: FC = () => {
  useSnackbarRef = useSnackbar()
  return null
}

export default {
  success(msg: string) {
    this.toast(msg, SEVERITY_LEVELS.SUCCESS)
  },
  warning(msg: string) {
    this.toast(msg, SEVERITY_LEVELS.WARNING)
  },
  info(msg: string) {
    this.toast(msg, SEVERITY_LEVELS.INFO)
  },
  error(msg: string) {
    this.toast(msg, SEVERITY_LEVELS.ERROR, SEVERITY_LEVELS.ERROR)
  },
  toast(msg: string, variant: VariantType = 'default', key?: string) {
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      preventDuplicate: true,
      ...(key && { key: key })
    })
  }
}
